// Thin wrapper around the shared useProductCatalogFetch — dispatches the
// resolved catalog to ProposalSlice instead of PurchaseLinkSlice (see
// usePurchaseLinkCatalog for that side).
import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {useProductCatalogFetch} from '../../../../../features/CatalogGrid/hooks/useProductCatalogFetch'
import {setProductConfigInfo} from '../../../../../app-store/ProposalSlice'

export function useProposalCatalog() {
  const dispatch = useDispatch()

  const onCatalogLoaded = useCallback(
    catalog => dispatch(setProductConfigInfo(catalog)),
    [dispatch],
  )

  return useProductCatalogFetch({onCatalogLoaded})
}
